export default __webpack_public_path__ + "static/Aury_walk_sequence_HP_1088x580_v005-fccd2315a5d5c68366503ad4bd31e836.mp4";